import { startDateOptions } from 'components/CallbackForm/start-date-options';
import { JOB_START_DATE } from 'lib/sdks/jobs-management/job.constants';

export type PreferredStartOption =
  (typeof JOB_START_DATE)[keyof typeof JOB_START_DATE];

export interface StartDateOption {
  label: string;
  value: PreferredStartOption;
  level?: number;
}

export type PreferredStartField =
  | {
      option: Exclude<PreferredStartOption, 'Urgent'>;
      label?: string;
    }
  | {
      option: 'Urgent';
      level: 48;
      label?: string;
    };

/**
 * Converts a preferredStart value to the job field format
 * @param preferredStart - The preferred start date value
 * @returns The formatted preferred start field or null if not found
 */
export const getPreferredStartField = (
  preferredStart?: PreferredStartOption,
): PreferredStartField | null => {
  if (!preferredStart) {
    return null;
  }

  const selectedOption = startDateOptions.find(
    option => option.value === preferredStart,
  );

  if (!selectedOption) {
    return null;
  }

  if (selectedOption.value === JOB_START_DATE.urgent) {
    return {
      option: selectedOption.value,
      level: 48,
      label: selectedOption.label,
    };
  }

  return {
    option: selectedOption.value,
    label: selectedOption.label,
  };
};
